const ethNetworkProviders = {
  testnet: 'https://ethereum-sepolia.blockpi.network/v1/rpc/public',
  mainnet: 'https://mainnet.infura.io/v3/',
}

const bnbNetworkProviders = {
  testnet: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  mainnet: 'https://bsc-dataseed.binance.org/',
}

const polygonNetworkProviders = {
  testnet: 'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78',
  mainnet: 'https://polygon-mainnet.infura.io/',
}

export const mvxNetworkProviders = {
  testnet: 'https://devnet-api.multiversx.com',
  mainnet: 'https://api.multiversx.com',
}

export const networksProviders = {
  BNB: bnbNetworkProviders,
  ETHEREUM: ethNetworkProviders,
  POLYGON: polygonNetworkProviders,
  MULTIVERSX: mvxNetworkProviders,
}

// Verification networks
const ethVerificationNetworks = {
  testnet: 'sepolia',
  mainnet: 'mainnet',
}

const bnbVerificationNetworks = {
  testnet: 'sepolia',
  mainnet: 'mainnet',
}

const polygonVerificationNetworks = {
  testnet: 'mumbai',
  mainnet: 'mainnet',
}

const mvxVerificationNetworks = {
  testnet: '',
  mainnet: '',
}

export type verificationNetworksType = {
  BNB: any
  ETHEREUM: any
  POLYGON: any
  MULTIVERSX: any
}

export const verificationNetworks: verificationNetworksType = {
  BNB: bnbVerificationNetworks,
  ETHEREUM: ethVerificationNetworks,
  POLYGON: polygonVerificationNetworks,
  MULTIVERSX: mvxVerificationNetworks,
}

export type networksType = {
  bnb: any
  ethereum: any
  polygon: any
  multiversx: any
}

export const networks: networksType = {
  bnb: bnbVerificationNetworks,
  ethereum: ethVerificationNetworks,
  polygon: polygonVerificationNetworks,
  multiversx: mvxVerificationNetworks,
}
